import BottomPopInMenu from "src/components/BottomPopInMenu";
import Noise from "src/components/Noise/Noise";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useDim from "src/hooks/useDim";
import { paddingLarge, paddingMedium, paddingXXL } from "src/styles/spacing";
import { BlurView, Text } from "src/swsh-native";
import FloatingSelectActions from "./components/FloatingSelectActions/FloatingSelectActions";

const FloatingSelect = ({ show }: { show?: boolean }) => {
	const numSelected = useGatheringStore((state) => Object.keys(state.selectedPhotos).length);
	const dim = useDim();

	return (
		<BottomPopInMenu
			show={show}
			style={{
				alignSelf: "center",
			}}
		>
			<BlurView
				style={{
					flexDirection: "row",
					alignItems: "center",
					paddingHorizontal: paddingXXL,
					paddingVertical: paddingLarge,
					borderRadius: 40,
					overflow: "hidden",
					width: Math.min(0.8 * dim.width, 320),
					justifyContent: "space-between",
				}}
				intensity="floating-menu"
			>
				<Noise
					opacity={0.1}
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
					}}
				/>
				<Text
					semibold
					style={{
						marginRight: paddingMedium,
					}}
				>
					{numSelected} selected
				</Text>
				<FloatingSelectActions />
			</BlurView>
		</BottomPopInMenu>
	);
};
export default FloatingSelect;
